module.exports = __webpack_public_path__ + "static/wrox3-654afb4cf11caef7f60a4758daa99cc0.png";